import { useTRPC } from '@/utils/trpc';
import { QueryStateHandler } from '@liza/ui/components/QueryStateHandler';
import { ImmunizationDetail } from '@liza/ui/components/records';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
};

export const Immunization = ({ id }: Props): React.ReactElement => {
  const { t } = useTranslation('records');
  const trpc = useTRPC();

  const immunizationQuery = useQuery(trpc.patient.immunization.get.queryOptions({ id }));

  return (
    <QueryStateHandler query={immunizationQuery} emptyMessage={t('noImmunizationsFound')}>
      {(data) => <ImmunizationDetail immunization={data.immunization} />}
    </QueryStateHandler>
  );
};
